import { render } from "./PlatformDetails.vue?vue&type=template&id=bc874e0c"
import script from "./PlatformDetails.vue?vue&type=script&lang=js"
export * from "./PlatformDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__